import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PortalApiService } from '../../portal-api.service';
import { PortalAuthService } from '../../portal-auth.service';
import { PortalBrandingService } from '../../portal-branding.service';

@Component({
	selector: 'portal-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

	email = '';
	password = '';
	staySignedIn = true;
	error = '';
	loading = false;

	// Where to land after signing in — the page the visitor was refused, passed
	// through as ?redirect by the auth guard. Null falls back to the dashboard.
	private redirect: string | null = null;

	constructor(
		private api: PortalApiService,
		private auth: PortalAuthService,
		public branding: PortalBrandingService,
		private router: Router,
		private route: ActivatedRoute
	) {}

	get coverUrl(): string | null { return this.branding.loginCoverUrl; }
	get companyInitial(): string { return (this.branding.companyName || '?').trim().charAt(0).toUpperCase(); }

	ngOnInit(): void {
		this.redirect = this.auth.safeReturnUrl(this.route.snapshot.queryParamMap.get('redirect'));
	}

	submit(): void {
		this.error = '';
		if (!this.email || !this.password) {
			this.error = 'Please enter your email address and password.';
			return;
		}

		this.loading = true;
		this.api.auth.login({ email: this.email, password: this.password, rememberme: this.staySignedIn ? 1 : 0 }, (res: any) => {
			this.loading = false;
			this.branding.apply(res?.branding);
			this.auth.setUser(res?.user || null);
			// Back to where they were headed; the dashboard if the stored URL no longer
			// resolves (e.g. access to that project was since removed).
			this.router.navigateByUrl(this.redirect || '/').catch(() => this.router.navigate(['/']));
		}, (err: any) => {
			this.loading = false;
			this.error = err?.message || 'Unable to sign in. Please try again.';
		});
	}
}
